// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import StarTwoToneSvg from "@ant-design/icons-svg/es/asn/StarTwoTone";
import AntdIcon from '../components/AntdIcon';

var StarTwoTone = function StarTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: StarTwoToneSvg
  }));
};

StarTwoTone.displayName = 'StarTwoTone';
export default React.forwardRef(StarTwoTone);